import type { RouteRecordRaw } from 'vue-router'

const bulkMessagingRoutes: RouteRecordRaw[] = [
  {
    path: '/bulk-messaging',
    name: 'BulkMessaging',
    component: () => import('@/pages/bulk-messaging/BulkMessagingPage.vue'),
    meta: {
      requiresAuth: true,
      layout: 'DashboardLayout',
      title: 'common.titles.bulk_messaging',
    },
  },
]

export default bulkMessagingRoutes
